import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Alert, Button, Card, CardBody, Form, Spinner, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import moment from "moment";
import { utils, writeFileXLSX } from "xlsx-js-style";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { allShop, clearallShop } from "../../redux/handlers/manage/allShop.handler";
import { allBrand, clearallBrand } from "../../redux/handlers/manage/allBrand.handler";
import { allSetUser, clearallSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { clearGetReportSkuActualDeliveryMonthly, getReportSkuActualDeliveryMonthly, getReportSkuActualDeliveryMonthlyByShop, getReportSkuGiftMonthly } from "../../redux/handlers/report/getReportSkuActualDeliveryMonthly.handler";
import { buildSkuActualDeliveryWorksheet, buildSkuGiftBranchWorksheet, getBrandMonthTotal, groupReportMonthsByYear } from "../../utils/skuActualDeliveryExcel";
var emptyReport = {
    months: [],
    brands: [],
    branches: [],
    branch_totals: {},
    grand_total: 0
};
var monthRangeOptions = [
    {
        value: "custom",
        label: "กำหนดเอง"
    },
    {
        value: "1",
        label: "เดือนนี้"
    },
    {
        value: "previous_month",
        label: "เดือนที่ผ่านมา"
    },
    {
        value: "3",
        label: "3 เดือนย้อนหลัง"
    },
    {
        value: "6",
        label: "6 เดือนย้อนหลัง"
    },
    {
        value: "9",
        label: "9 เดือนย้อนหลัง"
    },
    {
        value: "12",
        label: "12 เดือนย้อนหลัง"
    }
];
var numberText = function(value) {
    var quantity = Number(value || 0);
    return quantity === 0 ? "" : quantity.toLocaleString("en-US");
};
var giftTypeOptions = [
    {
        value: "GIFT",
        label: "ของแถม"
    },
    {
        value: "TESTER",
        label: "ตัวทดลอง"
    },
    {
        value: "ALL",
        label: "ทั้งหมด"
    }
];
var reservationStatusOptions = [
    {
        value: 1,
        label: "รอยืนยัน"
    },
    {
        value: 4,
        label: "กำลังจัดสินค้า"
    },
    {
        value: 7,
        label: "ตรวจสอบสินค้า"
    },
    {
        value: 5,
        label: "รอส่งสินค้า"
    },
    {
        value: 2,
        label: "ส่งสินค้าแล้ว"
    },
    {
        value: 6,
        label: "ชำระแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    }
];
var defaultGiftStatusIds = [
    5,
    2,
    6
];
export function ReportSkuActualDeliveryMonthly(param) {
    var _param_groupByShop = param.groupByShop, groupByShop = _param_groupByShop === void 0 ? false : _param_groupByShop, _param_giftOnly = param.giftOnly, giftOnly = _param_giftOnly === void 0 ? false : _param_giftOnly;
    var _giftTypeOptions_find, _giftTypeOptions_find1;
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var modalContextRef = useRef({
        modalObj: modalObj,
        setModalObj: setModalObj
    });
    var allShopReducer = useAppSelector(function(state) {
        return state.allShopReducer;
    });
    var allBrandReducer = useAppSelector(function(state) {
        return state.allBrandReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var reportReducer = useAppSelector(function(state) {
        return state.getReportSkuActualDeliveryMonthlyReducer;
    });
    var _useState = _sliced_to_array(useState(null), 2), startMonth = _useState[0], setStartMonth = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), endMonth = _useState1[0], setEndMonth = _useState1[1];
    var _useState2 = _sliced_to_array(useState("custom"), 2), monthRange = _useState2[0], setMonthRange = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), shopId = _useState3[0], setShopId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), branchId = _useState4[0], setBranchId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), saleId = _useState5[0], setSaleId = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), brandId = _useState6[0], setBrandId = _useState6[1];
    var _useState7 = _sliced_to_array(useState("GIFT"), 2), giftType = _useState7[0], setGiftType = _useState7[1];
    var _useState8 = _sliced_to_array(useState(defaultGiftStatusIds), 2), giftStatusIds = _useState8[0], setGiftStatusIds = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), shops = _useState9[0], setShops = _useState9[1];
    var _useState10 = _sliced_to_array(useState(emptyReport), 2), report = _useState10[0], setReport = _useState10[1];
    var _useState11 = _sliced_to_array(useState(false), 2), hasSearched = _useState11[0], setHasSearched = _useState11[1];
    var _useState12 = _sliced_to_array(useState(""), 2), error = _useState12[0], setError = _useState12[1];
    var loading = reportReducer.isFetching;
    useEffect(function() {
        modalContextRef.current = {
            modalObj: modalObj,
            setModalObj: setModalObj
        };
    }, [
        modalObj,
        setModalObj
    ]);
    useEffect(function() {
        dispatch(allShop(modalContextRef.current));
        dispatch(allBrand({
            status: 1
        }, modalContextRef.current));
        dispatch(allSetUser(modalContextRef.current));
        return function() {
            dispatch(clearallShop());
            dispatch(clearallBrand());
            dispatch(clearallSetUser());
            dispatch(clearGetReportSkuActualDeliveryMonthly());
        };
    }, [
        dispatch
    ]);
    useEffect(function() {
        var _allShopReducer_data;
        var data = (_allShopReducer_data = allShopReducer.data) === null || _allShopReducer_data === void 0 ? void 0 : _allShopReducer_data.data;
        if (Array.isArray(data)) setShops(data);
    }, [
        allShopReducer.data
    ]);
    useEffect(function() {
        if (reportReducer.data && !reportReducer.isError) {
            var data = reportReducer.data.data || emptyReport;
            setReport({
                months: Array.isArray(data.months) ? data.months : [],
                brands: Array.isArray(data.brands) ? data.brands : [],
                branches: Array.isArray(data.branches) ? data.branches : [],
                branch_totals: data.branch_totals || {},
                grand_total: Number(data.grand_total || 0)
            });
            setHasSearched(true);
        }
    }, [
        reportReducer
    ]);
    var shopOptions = useMemo(function() {
        return shops.map(function(shop) {
            return {
                value: shop.sh_shop_id,
                label: shop.sh_shop_name
            };
        });
    }, [
        shops
    ]);
    var branchOptions = useMemo(function() {
        var source = shopId ? shops.filter(function(shop) {
            return Number(shop.sh_shop_id) === Number(shopId);
        }) : shops;
        return source.flatMap(function(shop) {
            return (shop.shBranch || []).map(function(branch) {
                return {
                    value: branch.sh_branch_id,
                    label: shopId ? branch.sh_branch_name : "".concat(branch.sh_branch_name, " (").concat(shop.sh_shop_name, ")")
                };
            });
        });
    }, [
        shopId,
        shops
    ]);
    var saleOptions = useMemo(function() {
        var _allSetUserReducer_data;
        var users = ((_allSetUserReducer_data = allSetUserReducer.data) === null || _allSetUserReducer_data === void 0 ? void 0 : _allSetUserReducer_data.data) || [];
        return users.filter(function(user) {
            return Number(user.sys_user_role_id) === 3;
        }).map(function(user) {
            return {
                value: user.sys_user_id,
                label: "".concat(user.sys_user_fullname || "-").concat(user.sys_user_nname ? " (".concat(user.sys_user_nname, ")") : "")
            };
        }).sort(function(a, b) {
            return a.label.localeCompare(b.label, "th");
        });
    }, [
        allSetUserReducer.data
    ]);
    var brandOptions = useMemo(function() {
        var _allBrandReducer_data;
        var brands = ((_allBrandReducer_data = allBrandReducer.data) === null || _allBrandReducer_data === void 0 ? void 0 : _allBrandReducer_data.data) || [];
        return brands.map(function(brand) {
            return {
                value: brand.set_brand_id,
                label: brand.set_brand_name || brand.set_brand_nameen || "-"
            };
        }).sort(function(a, b) {
            return a.label.localeCompare(b.label, "th");
        });
    }, [
        allBrandReducer.data
    ]);
    var clearResult = function() {
        setReport(emptyReport);
        setHasSearched(false);
        setError("");
    };
    var handleMonthRangeChange = function(option) {
        var nextRange = (option === null || option === void 0 ? void 0 : option.value) || "custom";
        setMonthRange(nextRange);
        if (nextRange === "custom") {
            clearResult();
            return;
        }
        var currentMonth = moment().startOf("month");
        if (nextRange === "previous_month") {
            var previousMonth = currentMonth.clone().subtract(1, "month");
            setStartMonth(previousMonth.toDate());
            setEndMonth(previousMonth.toDate());
            clearResult();
            return;
        }
        var monthCount = Number(nextRange);
        setStartMonth(currentMonth.clone().subtract(Math.max(monthCount - 1, 0), "months").toDate());
        setEndMonth(currentMonth.toDate());
        clearResult();
    };
    var handleDateRangeChange = function(preset) {
        setMonthRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setStartMonth(range.startDate);
            setEndMonth(range.endDate);
        }
        clearResult();
    };
    var handleSearch = function() {
        if (!startMonth || !endMonth) {
            clearResult();
            setError(giftOnly ? "กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุดให้ครบถ้วน" : "กรุณาเลือกเดือนเริ่มต้นและเดือนสิ้นสุดให้ครบถ้วน");
            return;
        }
        var dateUnit = giftOnly ? "day" : "month";
        if (moment(endMonth).isBefore(startMonth, dateUnit)) {
            clearResult();
            setError(giftOnly ? "วันที่สิ้นสุดต้องไม่น้อยกว่าวันที่เริ่มต้น" : "เดือนสิ้นสุดต้องไม่น้อยกว่าเดือนเริ่มต้น");
            return;
        }
        if (groupByShop && !brandId) {
            clearResult();
            setError("กรุณาเลือกแบรนด์");
            return;
        }
        setError("");
        setHasSearched(true);
        setReport(emptyReport);
        dispatch((giftOnly ? getReportSkuGiftMonthly : groupByShop ? getReportSkuActualDeliveryMonthlyByShop : getReportSkuActualDeliveryMonthly)(_object_spread({}, giftOnly ? {
            sdate: moment(startMonth).format("YYYY-MM-DD"),
            edate: moment(endMonth).format("YYYY-MM-DD"),
            giftType: giftType,
            statusids: giftStatusIds
        } : {
            smonth: moment(startMonth).format("YYYY-MM"),
            emonth: moment(endMonth).format("YYYY-MM")
        }, shopId && {
            shopid: Number(shopId)
        }, branchId && {
            shbranchid: Number(branchId)
        }, saleId && {
            saleid: Number(saleId)
        }, brandId && {
            brandid: Number(brandId)
        }), modalContextRef.current));
    };
    var handleExport = function() {
        var _giftTypeOptions_find;
        var giftLabel = ((_giftTypeOptions_find = giftTypeOptions.find(function(option) {
            return option.value === giftType;
        })) === null || _giftTypeOptions_find === void 0 ? void 0 : _giftTypeOptions_find.label) || "ของแถม";
        var worksheet = giftOnly ? buildSkuGiftBranchWorksheet(report, {
            heading: "ร้านค้าที่เบิก".concat(giftLabel, " (จำนวน ชิ้น)")
        }) : buildSkuActualDeliveryWorksheet(report, {
            showBrandSequence: !groupByShop
        });
        var workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, giftOnly ? "SKU GIFT" : "SKU SALES");
        writeFileXLSX(workbook, "".concat(giftOnly ? "sku_gift_".concat(giftType.toLowerCase()) : "sku_actual_delivery", "_").concat(moment(startMonth).format(giftOnly ? "YYYY_MM_DD" : "YYYY_MM"), "_").concat(moment(endMonth).format(giftOnly ? "YYYY_MM_DD" : "YYYY_MM"), ".xlsx"));
    };
    var groups = groupReportMonthsByYear(report.months);
    var reportGroups = giftOnly ? report.brands : groupByShop ? report.branches : report.brands;
    var hasRows = reportGroups.some(function(group) {
        return group.products.length > 0;
    });
    var totalShops = groupByShop || giftOnly ? new Set(report.branches.map(function(branch) {
        return branch.shop_id;
    }).filter(function(currentShopId) {
        return currentShopId !== null && currentShopId !== undefined;
    })).size : 0;
    var totalBranches = groupByShop || giftOnly ? new Set(report.branches.filter(function(branch) {
        return branch.branch_id !== null && branch.branch_id !== undefined;
    }).map(function(branch) {
        var _branch_shop_id;
        return "".concat((_branch_shop_id = branch.shop_id) !== null && _branch_shop_id !== void 0 ? _branch_shop_id : "none", ":").concat(branch.branch_id);
    })).size : 0;
    var totalBrands = !groupByShop ? new Set(report.brands.map(function(brand) {
        return brand.brand_id;
    }).filter(function(currentBrandId) {
        return currentBrandId !== null && currentBrandId !== undefined;
    })).size : 0;
    var totalSkus = !groupByShop ? new Set(report.brands.flatMap(function(brand) {
        return brand.products.map(function(product) {
            return product.product_id;
        }).filter(function(currentProductId) {
            return currentProductId !== null && currentProductId !== undefined;
        });
    })).size : 0;
    var reportTitle = giftOnly ? "รายงานของแถม SKU รายเดือน" : groupByShop ? "รายงานจำนวนส่งจริง SKU รายเดือน ตามร้านค้า" : "รายงานจำนวนส่งจริง SKU รายเดือน";
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "tc-7",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item active",
                                    children: reportTitle
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: reportTitle
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-3 mb-3",
                children: /*#__PURE__*/ _jsxs(CardBody, {
                    className: "px-xl-3",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4 align-items-end",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-6",
                                    children: giftOnly ? /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                        value: monthRange,
                                        onChange: handleDateRangeChange
                                    }) : /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ช่วงวันที่"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                options: monthRangeOptions,
                                                value: monthRangeOptions.find(function(option) {
                                                    return option.value === monthRange;
                                                }) || monthRangeOptions[0],
                                                onChange: handleMonthRangeChange,
                                                isClearable: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-0 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    giftOnly ? "วันที่สร้างใบจองเริ่มต้น" : "เดือนเริ่มต้น",
                                                    " ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: startMonth,
                                                onChange: function(date) {
                                                    setMonthRange("custom");
                                                    setStartMonth(date);
                                                    if (endMonth && date && moment(endMonth).isBefore(date, giftOnly ? "day" : "month")) setEndMonth(null);
                                                    clearResult();
                                                },
                                                dateFormat: giftOnly ? "yyyy-MM-dd" : "yyyy-MM",
                                                showMonthYearPicker: !giftOnly,
                                                className: "form-control px-2 mb-2 input-equal",
                                                placeholderText: giftOnly ? "เลือกวันที่เริ่มต้น" : "เลือกเดือนเริ่มต้น",
                                                maxDate: endMonth,
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-0 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    giftOnly ? "วันที่สร้างใบจองสิ้นสุด" : "เดือนสิ้นสุด",
                                                    " ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: endMonth,
                                                onChange: function(date) {
                                                    setMonthRange("custom");
                                                    setEndMonth(date);
                                                    clearResult();
                                                },
                                                dateFormat: giftOnly ? "yyyy-MM-dd" : "yyyy-MM",
                                                showMonthYearPicker: !giftOnly,
                                                className: "form-control px-2 mb-2 input-equal",
                                                placeholderText: giftOnly ? "เลือกวันที่สิ้นสุด" : "เลือกเดือนสิ้นสุด",
                                                minDate: startMonth,
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                giftOnly ? /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ประเภทของแถม"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                options: giftTypeOptions,
                                                value: giftTypeOptions.find(function(option) {
                                                    return option.value === giftType;
                                                }),
                                                onChange: function(option) {
                                                    setGiftType((option === null || option === void 0 ? void 0 : option.value) || "GIFT");
                                                    clearResult();
                                                },
                                                isClearable: false
                                            })
                                        ]
                                    })
                                }) : null,
                                giftOnly ? /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-4 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "สถานะ"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                options: reservationStatusOptions,
                                                value: reservationStatusOptions.filter(function(option) {
                                                    return giftStatusIds.includes(option.value);
                                                }),
                                                onChange: function(options) {
                                                    setGiftStatusIds((options || []).map(function(option) {
                                                        return option.value;
                                                    }));
                                                    clearResult();
                                                },
                                                placeholder: "ทั้งหมด",
                                                isMulti: true,
                                                isClearable: true,
                                                closeMenuOnSelect: false
                                            })
                                        ]
                                    })
                                }) : null,
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                placeholder: "ทั้งหมด",
                                                options: shopOptions,
                                                value: shopOptions.find(function(item) {
                                                    return item.value === shopId;
                                                }) || null,
                                                onChange: function(option) {
                                                    setShopId((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    setBranchId("");
                                                    clearResult();
                                                },
                                                isClearable: true,
                                                isLoading: allShopReducer.isFetching
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "สาขาร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                placeholder: "ทั้งหมด",
                                                options: branchOptions,
                                                value: branchOptions.find(function(item) {
                                                    return item.value === branchId;
                                                }) || null,
                                                onChange: function(option) {
                                                    setBranchId((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    clearResult();
                                                },
                                                isClearable: true,
                                                isLoading: allShopReducer.isFetching
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "เซลล์"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                placeholder: "ทั้งหมด",
                                                options: saleOptions,
                                                value: saleOptions.find(function(item) {
                                                    return item.value === saleId;
                                                }) || null,
                                                onChange: function(option) {
                                                    setSaleId((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    clearResult();
                                                },
                                                isClearable: true,
                                                isLoading: allSetUserReducer.isFetching
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    "แบรนด์",
                                                    groupByShop ? /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger",
                                                        children: " *"
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                placeholder: "ทั้งหมด",
                                                options: brandOptions,
                                                value: brandOptions.find(function(item) {
                                                    return item.value === brandId;
                                                }) || null,
                                                onChange: function(option) {
                                                    setBrandId((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    clearResult();
                                                },
                                                isClearable: true,
                                                isLoading: allBrandReducer.isFetching
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-6",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "danger",
                                        className: "w-100 mb-2",
                                        onClick: handleSearch,
                                        disabled: loading,
                                        children: loading ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Spinner, {
                                                    animation: "border",
                                                    size: "sm",
                                                    className: "me-2"
                                                }),
                                                "กำลังค้นหา"
                                            ]
                                        }) : "ค้นหา"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-secondary fs-14 mt-2",
                            children: [
                                "หมายเหตุ: ",
                                giftOnly ? "ค้นหาตามวันที่สร้างใบจอง และรายการประเภท".concat(((_giftTypeOptions_find = giftTypeOptions.find(function(option) {
                                    return option.value === giftType;
                                })) === null || _giftTypeOptions_find === void 0 ? void 0 : _giftTypeOptions_find.label) || "ของแถม") : "แสดงเฉพาะใบจองสถานะ “จัดส่งแล้ว” และ “ชำระแล้ว”",
                                " โดยจำนวนที่แสดงเป็นจำนวนส่งจริง หน่วยเป็นชิ้นหรือหน่วยที่เล็กที่สุด"
                            ]
                        }),
                        error ? /*#__PURE__*/ _jsx(Alert, {
                            variant: "danger",
                            className: "mt-2 mb-0",
                            children: error
                        }) : null
                    ]
                })
            }),
            hasSearched ? /*#__PURE__*/ _jsxs("div", {
                className: "row g-3 mb-3",
                children: [
                    groupByShop || giftOnly ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6 col-xl-3",
                                children: /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-3 h-100",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        className: "px-3 py-3",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-14 tc-7",
                                                children: "จำนวนร้านค้าทั้งหมด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-24 fw-semibold",
                                                children: loading ? "-" : totalShops.toLocaleString("en-US")
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6 col-xl-3",
                                children: /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-3 h-100",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        className: "px-3 py-3",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-14 tc-7",
                                                children: "จำนวนสาขาทั้งหมด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-24 fw-semibold",
                                                children: loading ? "-" : totalBranches.toLocaleString("en-US")
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }) : null,
                    !groupByShop ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6 col-xl-3",
                                children: /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-3 h-100",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        className: "px-3 py-3",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-14 tc-7",
                                                children: "จำนวนแบรนด์ทั้งหมด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-24 fw-semibold",
                                                children: loading ? "-" : totalBrands.toLocaleString("en-US")
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6 col-xl-3",
                                children: /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-3 h-100",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        className: "px-3 py-3",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-14 tc-7",
                                                children: "จำนวน SKU ทั้งหมด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-24 fw-semibold",
                                                children: loading ? "-" : totalSkus.toLocaleString("en-US")
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-3 mb-3",
                children: /*#__PURE__*/ _jsxs(CardBody, {
                    className: "p-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "d-flex justify-content-end p-3 pb-0",
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "success",
                                onClick: handleExport,
                                disabled: !hasRows || loading,
                                children: "Export Excel"
                            })
                        }),
                        !hasSearched ? /*#__PURE__*/ _jsxs("div", {
                            className: "text-center text-secondary py-5",
                            children: [
                                "กรุณาเลือก",
                                giftOnly ? "ช่วงวันที่" : "ช่วงเดือน",
                                " แล้วกดค้นหาเพื่อแสดงรายงาน"
                            ]
                        }) : !loading && !hasRows ? /*#__PURE__*/ _jsx("div", {
                            className: "text-center text-secondary py-5",
                            children: "ไม่พบข้อมูลตามเงื่อนไขที่เลือก"
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "table-responsive p-3",
                            children: giftOnly ? /*#__PURE__*/ _jsxs(Table, {
                                bordered: true,
                                hover: true,
                                className: "align-middle mb-0 text-nowrap",
                                children: [
                                    /*#__PURE__*/ _jsxs("thead", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {
                                                        rowSpan: 2,
                                                        colSpan: 2,
                                                        className: "text-center align-middle",
                                                        children: "รายการสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("th", {
                                                        colSpan: report.branches.length + 1,
                                                        className: "text-center align-middle",
                                                        style: {
                                                            backgroundColor: "#d9ead3"
                                                        },
                                                        children: [
                                                            "ร้านค้าที่เบิก",
                                                            ((_giftTypeOptions_find1 = giftTypeOptions.find(function(option) {
                                                                return option.value === giftType;
                                                            })) === null || _giftTypeOptions_find1 === void 0 ? void 0 : _giftTypeOptions_find1.label) || "ของแถม",
                                                            " (จำนวน ชิ้น)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("tr", {
                                                style: {
                                                    backgroundColor: "#f4cccc"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {
                                                        className: "text-center align-middle",
                                                        children: "TOTAL"
                                                    }),
                                                    report.branches.map(function(branch) {
                                                        return /*#__PURE__*/ _jsx("th", {
                                                            className: "text-center align-middle",
                                                            children: branch.label
                                                        }, branch.key);
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("tbody", {
                                        children: [
                                            report.brands.flatMap(function(brand) {
                                                return [
                                                    /*#__PURE__*/ _jsxs("tr", {
                                                        className: "table-secondary",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("td", {}),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                className: "fw-bold",
                                                                children: brand.brand_name || "NO BRAND"
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {}),
                                                            report.branches.map(function(branch) {
                                                                return /*#__PURE__*/ _jsx("td", {}, branch.key);
                                                            })
                                                        ]
                                                    }, "brand-".concat(brand.brand_id, "-").concat(brand.brand_name))
                                                ].concat(_to_consumable_array(brand.products.map(function(product) {
                                                    return /*#__PURE__*/ _jsxs("tr", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: product.barcode || ""
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: product.product_name
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                className: "text-center",
                                                                children: numberText(product.total)
                                                            }),
                                                            report.branches.map(function(branch) {
                                                                var _product_branch_quantities;
                                                                var quantity = Number(((_product_branch_quantities = product.branch_quantities) === null || _product_branch_quantities === void 0 ? void 0 : _product_branch_quantities[branch.key]) || 0);
                                                                return /*#__PURE__*/ _jsx("td", {
                                                                    className: "text-center".concat(quantity > 1 ? " text-danger" : ""),
                                                                    children: numberText(quantity)
                                                                }, branch.key);
                                                            })
                                                        ]
                                                    }, "product-".concat(brand.brand_id, "-").concat(product.product_id, "-").concat(product.product_name));
                                                })));
                                            }),
                                            /*#__PURE__*/ _jsxs("tr", {
                                                className: "table-secondary fw-bold",
                                                children: [
                                                    /*#__PURE__*/ _jsx("td", {}),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: "TOTAL"
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        className: "text-center",
                                                        children: numberText(report.grand_total)
                                                    }),
                                                    report.branches.map(function(branch) {
                                                        var _report_branch_totals;
                                                        return /*#__PURE__*/ _jsx("td", {
                                                            className: "text-center",
                                                            children: numberText((_report_branch_totals = report.branch_totals) === null || _report_branch_totals === void 0 ? void 0 : _report_branch_totals[branch.key])
                                                        }, branch.key);
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ _jsxs(Table, {
                                bordered: true,
                                hover: true,
                                className: "align-middle mb-0 text-nowrap",
                                children: [
                                    /*#__PURE__*/ _jsxs("thead", {
                                        className: "table-light",
                                        children: [
                                            /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {
                                                        rowSpan: 2,
                                                        className: "text-center align-middle",
                                                        children: "#"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        rowSpan: 2,
                                                        className: "text-center align-middle",
                                                        children: "PRODUCT"
                                                    }),
                                                    groups.map(function(group) {
                                                        return /*#__PURE__*/ _jsx("th", {
                                                            colSpan: group.count,
                                                            className: "text-center",
                                                            children: group.year
                                                        }, group.year);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("tr", {
                                                children: report.months.map(function(month) {
                                                    return /*#__PURE__*/ _jsx("th", {
                                                        className: "text-center",
                                                        children: month.month
                                                    }, month.key);
                                                })
                                            })
                                        ]
                                    }),
                                    reportGroups.map(function(group, groupIndex) {
                                        return /*#__PURE__*/ _jsxs("tbody", {
                                            children: [
                                                /*#__PURE__*/ _jsxs("tr", {
                                                    className: "table-secondary",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "text-center",
                                                            children: groupIndex + 1
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            colSpan: report.months.length + 1,
                                                            className: "fw-bold",
                                                            children: groupByShop ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                children: [
                                                                    "ร้านค้า: ",
                                                                    group.shop_name || "NO SHOP",
                                                                    /*#__PURE__*/ _jsxs("span", {
                                                                        className: "ms-4",
                                                                        children: [
                                                                            "สาขา: ",
                                                                            group.branch_name || "NO BRANCH"
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : group.brand_name || "NO BRAND"
                                                        })
                                                    ]
                                                }),
                                                group.products.map(function(product, productIndex) {
                                                    return /*#__PURE__*/ _jsxs("tr", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("td", {
                                                                className: "text-center",
                                                                children: productIndex + 1
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: product.product_name
                                                            }),
                                                            report.months.map(function(month) {
                                                                var _product_shop_counts;
                                                                return /*#__PURE__*/ _jsxs("td", {
                                                                    className: "text-end",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: numberText(product.quantities[month.key])
                                                                        }),
                                                                        giftOnly ? /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-secondary",
                                                                            children: [
                                                                                "จำนวนร้านค้า: ",
                                                                                Number(((_product_shop_counts = product.shop_counts) === null || _product_shop_counts === void 0 ? void 0 : _product_shop_counts[month.key]) || 0).toLocaleString("en-US")
                                                                            ]
                                                                        }) : null
                                                                    ]
                                                                }, month.key);
                                                            })
                                                        ]
                                                    }, "".concat(product.product_id, "-").concat(product.product_name));
                                                }),
                                                /*#__PURE__*/ _jsxs("tr", {
                                                    className: "table-light fw-bold",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "text-center"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "text-end",
                                                            children: "TOTAL"
                                                        }),
                                                        report.months.map(function(month) {
                                                            var _group_shop_counts;
                                                            return /*#__PURE__*/ _jsxs("td", {
                                                                className: "text-end",
                                                                children: [
                                                                    numberText(getBrandMonthTotal(group, month.key)),
                                                                    giftOnly ? /*#__PURE__*/ _jsxs("div", {
                                                                        className: "text-secondary",
                                                                        children: [
                                                                            "จำนวนร้านค้า: ",
                                                                            Number(((_group_shop_counts = group.shop_counts) === null || _group_shop_counts === void 0 ? void 0 : _group_shop_counts[month.key]) || 0).toLocaleString("en-US")
                                                                        ]
                                                                    }) : null
                                                                ]
                                                            }, month.key);
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, groupByShop ? "".concat(group.shop_id, "-").concat(group.branch_id) : "".concat(group.brand_id, "-").concat(group.brand_name));
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
export function ReportSkuActualDeliveryMonthlyByShop() {
    return /*#__PURE__*/ _jsx(ReportSkuActualDeliveryMonthly, {
        groupByShop: true
    });
}
export function ReportSkuGiftMonthly() {
    return /*#__PURE__*/ _jsx(ReportSkuActualDeliveryMonthly, {
        giftOnly: true
    });
}
